export flightCitiesReducer = (state = [], action) -> state
